module.exports = __webpack_public_path__ + "static/media/august.755d0a4e.png";